import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { IPlayNextVideoIconProps } from "interfaces";
import { controllbarIconSize } from "helpers";

const PlayNextVideoIcon = (props: IPlayNextVideoIconProps) => {
    return (
        <Image
            src={IMAGES.playNext}
            width={controllbarIconSize.other}
            height={controllbarIconSize.other}
            alt="playNext-icon"
            className="pl-cursor-pointer"
            {...props}
        />
    );
};

export default PlayNextVideoIcon;
